/*
 * Module for creating and updating charts
 */

rs.module("controls/data/chart",

    ["ui/framework/theme-manager", "ui/framework/client-templates"],

    function (themeManager, clientTemplates) {

        var defaultPalette = {
            fills: ['#5090dc', '#b5b5b5'],
            strokes: ['#0056b2', '#838383']
        };

        function initialize(jsSelectors, chartOptions, emptyChartTemplateKey) {

            //set the container for the chart
            chartOptions.container = $.js(jsSelectors.chartContainer)[0];

            // set the no data overlay to be our custom template
            chartOptions.overlays = {
                noData: {
                    renderer: () => clientTemplates.render(emptyChartTemplateKey)
                }
            }

            return createChart(chartOptions);
        }

        //
        // Create a new chart
        //
        function createChart(options) {

            // Set chart theme.
            options.theme = _getChartTheme(options);

            // create the chart
            var chart = agCharts.AgCharts.create(options);

            // When the theme is changed we need to update the chart to use the new theme
            themeManager.onThemeChanged(function (params) {

                // set the new theme in the chart options and update the chart
                // as above when the chart was initialized, only use our default pallete for non pie charts
                options.theme = _getChartTheme(options);

                // update the chart
                chart.update(options);
            });

            return _createInstanceApi(chart, options);
        }

        //
        // Create the instance api that can be used to interact with this specific chart
        //
        function _createInstanceApi(chart, options) {

            var instanceApi = {
                chart: chart
            };

            //
            // Update the chart with new data
            //
            instanceApi.updateChart = function (chartData) {

                options.data = chartData;
                options.theme = _getChartTheme(options);

                instanceApi.chart.update(options);
            };

            return instanceApi;
        }

        //
        // Determine the theme to use for the given chart.
        //
        function _getChartTheme(options) {

            // Only use our default pallete for non pie charts
            // For pie charts you can have any number of 'slices' and we don't want to have to define an endless amount of colors to use
            // So for pie charts we just let ag charts pick the colors
            if (options.series.some((series) =>
                    series.type == "pie" ||
                    series.type == "line")) {
                return themeManager.getChartTheme();
            }
            else {
                return $.extend({}, themeManager.getChartTheme(), { palette: defaultPalette });
            }
        }

        // Exported public API
        var exports = {
            initialize,
            createChart
        };

        return exports;
    }
);